import React from "react"
// import iconepart from '../Resources/Partenaires.png'
import Partenaires from "./Partenaires.js"
import { FaireunDon } from "../Fonctions.js";
import '../Partenaire/Partenaire.css'
// import hrefs_json_gold from '../files/partenaires_gold_2026.json'
// import hrefs_json from '../files/partenaires2026.json'
import { Titre,Video } from "../Fonctions"

export default function xCourse() {
    return (
        <div id="Partenaires" className="Partenaire" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/filigrane.svg)`
        }}>
            <FaireunDon />
            <div className="container-fluid" id='pres-part'>
                <div className='row bandeau bleu bandeau-top'>
                    <div className={`col-xs-12`}>
                        <h1>Ce projet est propulsé par ceux qui nous aident et nous soutiennent.</h1>
                    </div>
                    {/* <div className={`col-xs-12 img ${col_small} hideinmobile`}>
                        <img src={iconepart} id="imgpart" alt='' />
                    </div> */}
                </div>
            </div>

            <div className="card-part">
                <Video file="manza.mp4" className='video-teaser-sm'/>
                <h3 style={{textAlign: "center", marginBottom: "5px"}}>
Un grand merci à <a style={{weight: "bold"}} href="https://www.manza-studio.com/" target="_blank" rel="noopener noreferrer">Manza Studio</a>  pour cette vidéo. 
                </h3>
                
            {/* </div>
            
            <div className="card-part"> */}
                    <Titre libelle="Partenaires Majeurs" color="blue" image="cddp" classTitle="small"/>
                <div className="row">
                    <div className="col">
                        <Partenaires partenaireType="Majeurs" />
                    </div>
                </div>
                <Titre libelle="Partenaires Financiers" color="blue" image="cddp" classTitle="small"/>
                <div className="row">
                    <div className="col">
                        <Partenaires partenaireType="Financiers" />
                    </div>
                </div>
                <Titre libelle="Partenaires Natures" color="blue" image="cddp" classTitle="small"/>
                <div className="row">
                    <div className="col">
                        <Partenaires partenaireType="Natures" />
                    </div>
                </div>
                <Titre libelle="Partenaires Institutionnels" color="blue" image="cddp" />
                <div className="row">
                    <div className="col">
                        <Partenaires partenaireType="Institutionnels" />
                    </div>
                </div>
            </div>
        </div>
    )
}